export default __webpack_public_path__ + "static/bbq-01-6b4b79f37ace5e9f3287292e0bef1171.jpg";